import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FeatureFlagsService } from 'src/app/shared/services/customer-api/feature-flags.service';

@Component({
  selector: 'app-event-sorting-toggle',
  templateUrl: './event-sorting-toggle.component.html',
})
export class EventSortingToggleComponent {
  @Input() sortByOptions: {
    value: string;
    icon: string;
    label?: string;
    tooltip?: string;
    class?: string;
  }[] = [];
  @Input() sortBy: string;
  @Input() hideTooltip: boolean = true; // Default value
  @Output() sortByChange = new EventEmitter<string>();

  customScore: string;

  constructor(public featureFlagsService: FeatureFlagsService) {
    this.customScore = this.featureFlagsService.scorelabSettings.defaultScore;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSortByChange(event: any) {
    this.sortByChange.emit(event.value);
  }
}
